<div class="image" [class.compact]="compact">
    <ng-container *ngIf="disabled">
        <div
            class="preview"
            [attr.title]="compact ? 'image' : null"
            [ngClass]="{loaded: !!existingImageUrl}">

            <div *ngIf="!existingImageUrl" class="preupload" [class]="loadingImageClass">
                <img class="icon-white" src="/assets/icons/image.svg" [ngClass]="{spin: imageUploading}">
                <div class="text">
                    upload image
                </div>
            </div>

            <!-- only once there is an image: an <img> with no src renders as a broken-image glyph -->
            <div class="uploaded" *ngIf="existingImageUrl">

                <img [src]="existingImageUrl" id="preview"
                    [ngClass]="{modifying: !!existingImageUrl && imageUploading}">

                <div *ngIf="!!existingImageUrl && imageUploading" class="modify-image-spinner">
                    <img class="icon-white" src="/assets/icons/image.svg" [ngClass]="{spin: imageUploading}">
                </div>
            </div>

        </div>
    </ng-container>

    <ng-container *ngIf="!disabled">
        <div
            class="preview"
            title="upload image"
            (click)="openFileExplorer()"
            [ngClass]="{loaded: !!existingImageUrl}">
            <div (click)="pasteImage($event)" class="paste-button" title="paste image">
                <img class="paste-icon icon-white" src="/assets/icons/clipboard.svg" alt="">
            </div>

            <div *ngIf="!existingImageUrl" class="preupload" [class]="loadingImageClass">
                <img class="icon-white" src="/assets/icons/image.svg" [ngClass]="{spin: imageUploading}">
                <div class="text">
                    Upload Image
                </div>
            </div>

            <!-- only once there is an image: an <img> with no src renders as a broken-image glyph -->
            <div class="uploaded" *ngIf="existingImageUrl">

                <img [src]="existingImageUrl" id="preview"
                    [ngClass]="{modifying: !!existingImageUrl && imageUploading}">

                <div *ngIf="!!existingImageUrl && imageUploading" class="modify-image-spinner">
                    <img class="icon-white" src="/assets/icons/image.svg" [ngClass]="{spin: imageUploading}">
                </div>
            </div>

        </div>
        <div class="hidden-actions">
            <input (change)="uploadImageFromInput($event)" type="file" id="upload" hidden />
        </div>
    </ng-container>

</div>
